import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ICategoryTreeNode} from "../tree-service/tree-data.model";

@Component({
    selector: 'app-delete-node',
    templateUrl: './delete-node.component.html',
    styleUrls: ['./delete-node.component.css']
})
export class DeleteNodeComponent {
    @Output() deletedNode = new EventEmitter();
    @Input() currentNode: ICategoryTreeNode;

    deleteNode() {
        this.deletedNode.emit(this.currentNode);
    }

}
